import { apiClient } from "./client";

export async function getBlogs() {
    const res = await apiClient.get("/api/blogs");
    return res.data;
}

export async function getBlogById(id) {
    const res = await apiClient.get(`/api/blogs/${id}`);
    return res.data;
}

export async function createBlog(payload) {
    const res = await apiClient.post("/api/blogs", payload);
    return res.data;
}

export async function updateBlog(id, payload) {
    const res = await apiClient.put(`/api/blogs/${id}`, payload);
    return res.data;
}

export async function deleteBlog(id) {
    const res = await apiClient.delete(`/api/blogs/${id}`);
    return res.data;
}

/**
 * @param {File} file
 * @returns {Promise<{ pdfUrl: string }>}
 */
export async function uploadBlogPdf(file) {
    const formData = new FormData();
    formData.append("pdf", file);
    const res = await apiClient.post("/api/blogs/upload-pdf", formData);
    return res.data;
}
